import { openModal, type ModalType } from './ui.slice.ts';
import type { AppThunk } from './index.ts';

/**
 * 모달을 Promise 로 다루기 위한 resolver 보관소.
 * Modal 컴포넌트가 버튼 처리 후 resolveDialog() 를 호출한다.
 */
let resolver: ((result: boolean) => void) | null = null;

/** Modal 컴포넌트에서 호출. 대기 중인 ask* 프라미스를 완료시킨다. */
export function resolveDialog(result: boolean): void {
  const fn = resolver;
  resolver = null;
  fn?.(result);
}

function waitForAnswer(): Promise<boolean> {
  // 이전 모달이 답 없이 교체되면 false 로 정리한다.
  resolveDialog(false);
  return new Promise<boolean>((resolve) => {
    resolver = resolve;
  });
}

/** 확인 버튼 하나짜리 알림. 닫힐 때까지 기다린다. */
export const askAlert =
  (message: string): AppThunk<Promise<void>> =>
  async (dispatch) => {
    dispatch(openModal({ type: 'alert', props: { message } }));
    await waitForAnswer();
  };

/** 확인/취소. 사용자의 선택을 boolean 으로 돌려준다. */
export const askConfirm =
  (message: string): AppThunk<Promise<boolean>> =>
  async (dispatch) => {
    dispatch(openModal({ type: 'confirm', props: { message } }));
    return waitForAnswer();
  };

/** 커스텀 모달(reward.save, watch.video 등) */
export const askCustom =
  (type: ModalType, message = ''): AppThunk<Promise<boolean>> =>
  async (dispatch) => {
    dispatch(openModal({ type, props: { message } }));
    return waitForAnswer();
  };
